import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  AboutDialogComponent,
  ColumnConfigEditorComponent,
  ConceptViewDialogComponent,
  ConfigurationSelectorComponent,
  DebugPanelComponent,
  DomainBreadcrumbsComponent,
  DomainItemComponent,
  ExternalRedirectComponent,
  FeedbackDialogComponent,
  KeycloakAuthComponent
} from './components';
import {PoweredByComponent} from '@twpub/shared/components';
import {PrettyDatePipe} from './pipes/pretty-date.pipe';
import {SanitizePipe} from './pipes/sanitize.pipe';
import {
  AttachmentRenderDirective,
  AttachmentRenderWrapperComponent,
  DictionarySelectorDirective,
  DictionaryWrapperComponent,
  DomainSelectorDirective,
  DomainWrapperComponent,
  FooterDirective,
  FooterWrapperComponent,
  HeaderDirective,
  HeaderWrapperComponent,
  LogoDirective,
  LogoWrapperComponent,
  PreambleDirective,
  PreambleWrapperComponent,
  ResultListDirective,
  ResultListWrapperComponent,
  ResultPageDirective,
  ResultPageWrapperComponent,
  ResultViewDirective,
  ResultViewWrapperComponent,
  SearchFieldDirective,
  SearchFieldWrapperComponent,
  SearchPageDirective,
  SearchPageWrapperComponent,
  SectionSelectorDirective,
  SectionWrapperComponent,
  SourceLanguageSelectorDirective,
  SourceLanguageWrapperComponent,
  TargetLanguageSelectorDirective,
  TargetLanguageWrapperComponent
} from '@twpub/shared/components/wrappers';
import {
  FieldRenderComponent,
  InternalLinkRenderComponent,
  LinkRenderComponent,
  TermRenderComponent,
  VirtualFileContentDialogComponent
} from '@twpub/shared/components/renders';
import {GallerizeDirective} from 'ng-gallery/lightbox';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HttpErrorInterceptor} from '@twpub/shared/interceptors/http-error.interceptor';
import {AuthInterceptor} from '@twpub/shared/interceptors/auth.interceptor';
import {MaterialModule} from '@twpub/shared/material/material.module';
import {FilterWrapperComponent} from '@twpub/shared/components/wrappers/filter-wrapper/filter-wrapper.component';
import {FilterSelectorDirective} from '@twpub/shared/components/wrappers/filter-wrapper/filter-selector.directive';
import {JsonValidatorDirective} from './directives/json-validator.directive';
import {LineBreakPipe} from './pipes/line-break.pipe';
import {LicenseDisplayComponent} from './components/about-dialog/license-display/license-display.component';
import {TippyTooltipDirective} from './directives/tippy-tooltip.directive';
import {DragDropModule} from '@angular/cdk/drag-drop';

@NgModule({
  imports: [
    CommonModule, RouterModule, FormsModule, ReactiveFormsModule, MaterialModule, NgOptimizedImage, GallerizeDirective, DragDropModule,
    DebugPanelComponent, DictionaryWrapperComponent,
    DictionarySelectorDirective, HeaderWrapperComponent, HeaderDirective,
    FooterWrapperComponent, FooterDirective, PreambleWrapperComponent, PreambleDirective, SearchFieldWrapperComponent,
    SearchFieldDirective, SourceLanguageWrapperComponent, SourceLanguageSelectorDirective,
    TargetLanguageWrapperComponent, TargetLanguageSelectorDirective, ResultListWrapperComponent, ResultListDirective,
    ResultViewWrapperComponent, ResultViewDirective, SearchPageWrapperComponent, SearchPageDirective,
    ResultPageWrapperComponent, ResultPageDirective,
    ConfigurationSelectorComponent, SectionWrapperComponent, SectionSelectorDirective, PoweredByComponent,
    PrettyDatePipe, SanitizePipe, ExternalRedirectComponent, KeycloakAuthComponent, TermRenderComponent, FieldRenderComponent,
    LinkRenderComponent, ConceptViewDialogComponent, InternalLinkRenderComponent, VirtualFileContentDialogComponent,
    AttachmentRenderWrapperComponent, AttachmentRenderDirective, DomainWrapperComponent, DomainSelectorDirective,
    DomainBreadcrumbsComponent, DomainItemComponent, LogoWrapperComponent, LogoDirective,
    FilterWrapperComponent, FilterSelectorDirective, JsonValidatorDirective, LineBreakPipe, AboutDialogComponent,
    LicenseDisplayComponent, TippyTooltipDirective, ColumnConfigEditorComponent, FeedbackDialogComponent
  ],
  exports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, MaterialModule,
    DebugPanelComponent, HeaderWrapperComponent, FooterWrapperComponent, PreambleWrapperComponent,
    DictionaryWrapperComponent, SearchFieldWrapperComponent, ResultViewWrapperComponent,
    SourceLanguageWrapperComponent, TargetLanguageWrapperComponent, ResultListWrapperComponent,
    ConfigurationSelectorComponent, SectionWrapperComponent, PoweredByComponent, PrettyDatePipe,
    TermRenderComponent, FieldRenderComponent, LinkRenderComponent, DomainWrapperComponent,
    AttachmentRenderWrapperComponent, DomainBreadcrumbsComponent, LogoWrapperComponent, FilterWrapperComponent,
    DomainItemComponent, JsonValidatorDirective, TippyTooltipDirective, ColumnConfigEditorComponent
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true}
  ]
})
export class SharedModule {
}
